import { tinymcePasteIdentifierTag } from 'rich-text-lib/constants/paste';
import { getPastePreProcessWithConfig } from 'rich-text-lib/lib/pastePreProcess';
import { transformHtml, getPastePreProcessHtmlTransforms } from 'rich-text-lib/lib/pastePreProcessTransform';
import { convertUrlToEmbedData } from 'rich-text-lib/utils/embedSrc';
import { compose } from 'rich-text-lib/utils/iterables';
import parseHTML from 'rich-text-lib/utils/parseHTML';
import { getPluginSetting } from '../utils';
import { PASTE_SETTINGS, hspasteConfig } from '../constants/hspaste';
export const getPastePreProcessTransform = pasteInfo => {
  const {
    pasteSource,
    type,
    pasteContent,
    converter
  } = pasteInfo;
  let didTransform = false;
  let transformedContent = pasteContent;
  const transformConverters = [];
  if (type === 'html') {
    const {
      transformers: preProcessTransformers,
      converters: preProcessConverters
    } = getPastePreProcessHtmlTransforms(pasteSource);
    if (preProcessTransformers.length) {
      transformedContent = transformHtml(pasteContent, preProcessTransformers);
      didTransform = true;
    }
    if (preProcessConverters.length) {
      transformConverters.push(...preProcessConverters);
      didTransform = true;
    }
  }
  const composedTransformConverter = compose(...transformConverters, converter);
  return {
    didTransform,
    transformedContent,
    composedTransformConverter
  };
};
const imageRegex = /<img/;
export const getPasteInfo = (event, pasteConfig) => {
  const dataTransfer = event.clipboardData;
  const pastePreProcessWithConfig = getPastePreProcessWithConfig(pasteConfig);
  let type = 'unknown';
  let pasteContent = undefined;
  let hasImages = undefined;
  if (dataTransfer && dataTransfer.getData) {
    if (pasteConfig.allowEmbedUrlPasting) {
      const embedData = convertUrlToEmbedData(dataTransfer.getData('text/plain'));
      if (embedData) {
        return {
          type: 'plaintext',
          embedData
        };
      }
    }
    if (dataTransfer.getData('text/html')) {
      type = 'html';
      pasteContent = dataTransfer.getData('text/html');
      hasImages = imageRegex.test(pasteContent);
    } else if (dataTransfer.getData('text/plain')) {
      type = 'plaintext';
      pasteContent = dataTransfer.getData('text/plain');
    } else if (dataTransfer.types.includes('Files')) {
      type = 'file';
    }
    if (dataTransfer.getData('x-tinymce/html')) {
      pasteContent = `${tinymcePasteIdentifierTag}${pasteContent}`;
    }
  }
  const {
    converter,
    converterName: pasteSource
  } = pastePreProcessWithConfig(pasteContent);
  return {
    type,
    converter,
    pasteSource,
    pasteContent,
    hasImages
  };
};
export const transformImageSizeStyle = html => {
  const body = parseHTML(html);
  Array.from(body.getElementsByTagName('img')).forEach(element => {
    const {
      width,
      height
    } = element.style;
    if (width) {
      element.setAttribute('width', width.replace(/[A-Za-z]./, ''));
    }
    if (height) {
      element.setAttribute('height', height.replace(/[A-Za-z]./, ''));
    }
  });
  return body.innerHTML;
};
export const constructPasteConfig = editor => {
  let pasteConfig = {};
  const pastePluginSettings = getPluginSetting(editor, PASTE_SETTINGS);
  if (pastePluginSettings) {
    const {
      [hspasteConfig.EMBED_URL_PASTING]: allowEmbedUrlPasting,
      [hspasteConfig.CLEAR_ALL_STYLES]: clearAllStyles,
      [hspasteConfig.DEFAULT_ATTRIBUTES_MAP]: defaultAttributesMap,
      [hspasteConfig.DEFAULT_STYLES_MAP]: defaultStylesMap,
      [hspasteConfig.FORMAT_TRANSFORM_MAP]: formatTransformMap,
      [hspasteConfig.IMAGES_UPLOAD_FILE_ACCESS]: uploadedFileAccess
    } = pastePluginSettings;
    pasteConfig = {
      allowEmbedUrlPasting,
      clearAllStyles,
      defaultStylesMap,
      defaultAttributesMap,
      formatTransformMap,
      uploadedFileAccess
    };
  }
  return pasteConfig;
};